import { Form, Input, Spin } from 'antd';
import { useEffect, useState } from 'react';
import './index.css';
import InputDescription from '../quiz-input-show-description/quiz-input-show-description';
import { useQuizFormContext } from '../../hooks/quiz-form-context';
import { useParams } from 'react-router-dom';

const TextInput = ({
  title,
  name,
  size = 'large',
  Error,
  description,
  indexKey,
  allInputOnchageHandler,
  anwerRequirements,
  questionTooltip
}) => {
  const {
    allFormErrorsList,
    setContentFulErrorMsg,
    getInputValues,
    formValues
  } = useQuizFormContext();
  const { handbookId } = useParams();
  const [defaultValue, setDefaultValue] = useState(
    getInputValues(name, formValues)?.value || ''
  ); // Initial default value

  useEffect(() => {
    // Fetch the default value asynchronously to show in input field
    const fetchDefaultValue = () => {
      const defaultValueFromForm = getInputValues(name, formValues)?.value;
      setDefaultValue(defaultValueFromForm); // Update default value or set empty string if no value fetched
    };

    fetchDefaultValue();
  }, [name, formValues?.length]); // Fetch default value whenever name or formValues change

  function handleInputChange(e) {
    const { name, value } = e.target;
    allInputOnchageHandler(indexKey, title, name, value);
  }
  // Storing error msg value in state
  useEffect(() => {
    if (Error) {
      setContentFulErrorMsg((prev) => ({ ...prev, [name]: Error }));
    }
  }, [Error]);

  return (
    <>
      <Form.Item
        label={description && <InputDescription description={description} questionTooltip={questionTooltip} />}
        name={name}
        className="input-label-container"
        required={!!Error}
      >
        <Input
          size={size}
          className={`${allFormErrorsList[name] ? 'error-warning' : 'textarea-input-text'
            } ${size}`}
          name={name}
          onChange={handleInputChange}
          defaultValue={defaultValue || getInputValues(name, formValues)?.value}
          maxLength={50}
        />
      </Form.Item>

      {allFormErrorsList[name] && <span className="error-message">{Error}</span>}
      {getInputValues(name, formValues)?.value && getInputValues(name, formValues)?.value?.length >= 50 && <span className="error-message">Maximum character limit is 50</span>}
    </>
  );
};

export default TextInput;